<template>
  <ChatbotsTemplate />
</template>
<script>
import ChatbotsTemplate from "@/app/chatbots/components/templates/ChatbotsTemplate.vue";

export default {
  name: "Chatbots",
  components: { ChatbotsTemplate },
};
</script>
<style lang="sass" scoped>
.chatbots
  // height: 100vh
</style>
